import { db } from "../../constants/firebase"

export const setGeoPoint = ((uid, obj) => {
    db.collection('locations').doc(uid).set({ lat: obj.latitude }, { merge: true })
    db.collection('locations').doc(uid).set({ lon: obj.longitude }, { merge: true })
    // db.collection('locations').doc(uid).set({ coords: obj }, { merge: true })
})